import { render, staticRenderFns } from "./editUserCard.vue?vue&type=template&id=9b425d3c"
import script from "./editUserCard.vue?vue&type=script&lang=ts"
export * from "./editUserCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports